const sxClasses = {
    root: {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "calc(100vh - 48px)",
        marginTop: "48px",
        overflow: "hidden",
        userSelect: "none"
    },
    container: {
        display: "flex",
        width: "100%",
        height: "100%",
        overflow: "hidden"
    },
    leftSidebarWrapper: {
        width: "auto",
        overflow: "hidden",
        flexShrink: 0
    },
    reactFlowWrapper: {
        flex: 1,
        height: "100%",
        position: "relative",
        "& .react-flow__node": {
            transition: "opacity 0.25s",
            "&:hover": {
                zIndex: "1 !important"
            },
            "&.fd-drop-target-valid": {
                outline: "3px solid #089bee",
                borderRadius: "16px"
            }
        }
    },
    rightSidebarWrapper: {
        width: "auto",
        height: "100%",
        maxWidth: "40vw",
        minWidth: "400px",
        zIndex: 6,
        "& .app-settings-tab": {
            padding: 2
        },
        "& .actions.card": {
            border: "none !important", // reset all border rules
            borderTop: "1px solid #D8E4F0 !important",
            borderRadius: "0 !important"
        }
    },
    piiSidebar: {
        width: "auto",
        height: "100%",
        backgroundColor: "white",
        borderLeft: "1px solid #e0e0e0",
        display: "flex",
        flexDirection: "column"
    },
    emptyStateWrapper: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 4,
        padding: 4
    },
    emptyStateContentWrapper: {
        maxWidth: "600px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center"
    },
    emptyStateSvg: {
        width: 100,
        height: "auto",
        marginBottom: 3
    },
    emptyStateTitleCreated: {
        mb: 2,
        background: theme =>
            `linear-gradient(135deg, ${theme.palette.secondary["500"]} 0%, ${theme.palette.additional.purple} 100%)`,
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        backgroundClip: "text"
    },
    emptyStateTitleDeployed: {
        mb: 2,
        background: theme =>
            `linear-gradient(135deg, ${theme.palette.primary["500"]} 0%, ${theme.palette.secondary["500"]} 100%)`,
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        backgroundClip: "text"
    },
    resizableSidebarBorder: {
        width: "4px",
        cursor: "col-resize",
        flexShrink: 0,
        alignSelf: "stretch",
        backgroundColor: "transparent",
        "&:hover": { backgroundColor: "greyscale.300" }
    }
};

export default sxClasses;
